import { Box, Button, Tooltip } from '@mui/material'
import { FilterIcon } from '../../icons'
import { IconButton } from '../button/IconButton'
import { ButtonSize } from '../button/button.model'
import { FilterActionsProps } from './FilterActions'
import { FilterPopUp, FilterProps } from './FilterPopUp'

export interface AdvancedFilterProps extends FilterProps, FilterActionsProps {
  filterTooltip: string
  filterSize?: ButtonSize
  buttonLabel?: string
  onOpenFilter: () => void
}
export const AdvancedFilter = ({
  filterTooltip,
  filterSize,
  open,
  children,
  width,
  filterActionLabel,
  resetActionLabel,
  formId,
  popUpMarginTop,
  buttonLabel,
  onFilter,
  onClose,
  onReset,
  onOpenFilter,
}: AdvancedFilterProps) => {
  return (
    <Box>
      {(buttonLabel && (
        <Button
          color='inherit'
          variant='contained'
          sx={{ flex: 'none' }}
          startIcon={<FilterIcon />}
          onClick={onOpenFilter}
        >
          {buttonLabel}
        </Button>
      )) || (
        <Tooltip title={filterTooltip}>
          <IconButton size={filterSize ?? 'medium'} onClick={onOpenFilter}>
            <FilterIcon fontSize={filterSize ?? 'medium'} />
          </IconButton>
        </Tooltip>
      )}

      <Box width='100%'>
        <FilterPopUp
          open={open}
          width={width}
          filterActionLabel={filterActionLabel}
          resetActionLabel={resetActionLabel}
          formId={formId}
          popUpMarginTop={popUpMarginTop}
          onFilter={onFilter}
          onClose={onClose}
          onReset={onReset}
        >
          {children}
        </FilterPopUp>
      </Box>
    </Box>
  )
}
